export const commune = state => state.commune
export const communes = state => state.communes
